import { Button, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router";
import { Links } from "src/constants";
import { useSession } from "src/hooks";
import { AnimatedErrorIcon } from "../AnimatedErrorIcon";

interface IProps {
  userId: string;
  isEngagementValid: boolean;
  hasPrimaryRole: boolean;
}

const RolesConfigurationWarningIcon = (props: IProps) => {
  const navigate = useNavigate();
  const { userId: sessionUserId } = useSession();
  const theme = useTheme();

  const isOwnProfile = props.userId === sessionUserId;

  return (
    <Tooltip
      title={
        <Stack spacing={0.5} sx={{
          alignItems: "flex-end"
        }}>
          <Stack spacing={0.25} sx={{
            alignItems: "flex-start"
          }}>
            <Typography variant="body2">Role Configuration Warning</Typography>
            <Typography variant="caption" sx={{ color: theme.palette.text.primary }}>
              One or more roles have been edited or removed which has caused the following issues with this person's
              role configuration:
            </Typography>
            {!props.hasPrimaryRole && (
              <Typography variant="caption" sx={{ color: theme.palette.text.primary }}>
                - No primary role designated
              </Typography>
            )}
            {!props.isEngagementValid && (
              <Typography variant="caption" sx={{ color: theme.palette.text.primary }}>
                - Engagement percentages do not add up to 100%
              </Typography>
            )}
          </Stack>
          {isOwnProfile && (
            <Button variant="tertiary" color="inherit" onClick={() => navigate(Links.UserSettings() + "#roles")}>
              Fix in Settings
            </Button>
          )}
        </Stack>
      }
    >
      <AnimatedErrorIcon sx={{ color: theme.palette.warning.main }} />
    </Tooltip>
  );
};

export { RolesConfigurationWarningIcon };
